<template>
    <flex-element
        :element-type="elementType"
        class-default-inline="f-flex-row f-px-2 f-py-1 f-text-blue-700 hover:f-text-blue-500"
        :class="[containerClasses, 'f-flex', 'f-flex-wrap']"
        :tag="tag || 'div'"
        exclude-classes
    >
        <select
            v-model="selected"
            class="f-w-1/1 f-bg-transparent"
            :class="[linkClasses, activeClass(index)]"
            :name="name"
            @input="onInput"
            @change="changeEvent"
        >
            <option
                value=""
                selected
            >
                Select {{ title }}
            </option>
            <option
                v-for="(element) in values"
                :key="element.id"
                :value="element.value"
                selected
            >
                {{ element.item ? element.item.name: element.value }}
                ({{ element.count }})
            </option>
        </select>
    </flex-element>
</template>

<script>
import { mapMutations } from 'vuex';

import baseOrganism from '@/mixins/base-organism/base-organism-smart';
import { Facet } from '@/data/data-models';
import listenOnRootMixin from '@/mixins/listen-on-root';
import { STATE_CLASSES } from '@/data/constants/classes';
import { FIRE_FLEX_EVENT } from '@/store/types/mutation-types';
import { getClassDefinition } from '@/utils/tailwind-helper';

export default {
    mixins: [baseOrganism, listenOnRootMixin],

    props: {
        displayName: {
            type: String,
            default: 'Facet Group',
        },

        values: {
            type: Array,
            default: () => [],
        },

        name: {
            type: String,
            default: '',
        },

        title: {
            type: String,
            default: '',
        },

        activeIndex: {
            type: Number,
            default: -1,
        },

        native: {
            type: Boolean,
            default: false,
        },

        tag: {
            type: String,
            default: 'div',
        },
    },

    data() {
        return {
            containerClassGroups: ['flexDirection'],
            navId: '',
            selected: '',
            inputValueNew: '',
        };
    },

    computed: {
        containerClasses() {
            return this.htmlClass.filter((className) => {
                const classDefinition = getClassDefinition(className);
                const { tailwindDefinitionProp } = classDefinition;

                return this.containerClassGroups.includes(tailwindDefinitionProp);
            });
        },

        linkClasses() {
            return this.htmlClass.filter((className) => {
                const classDefinition = getClassDefinition(className);
                const { tailwindDefinitionProp } = classDefinition;

                return !this.containerClassGroups.includes(tailwindDefinitionProp);
            });
        },

        formattedValues() {
            if (this.values) {
                const options = [];
                this.values.forEach((element) => {
                    options.push({ text: `${ element.item ? element.item.name : element.value } (${ element.count })`, value: element.value });
                });
                return options;
            }
            return this.values;
        },

        updatedElement() {
            return new Facet({
                ...this.updatedBaseElement,
                tag: this.tag || 'div',
            });
        },
    },

    methods: {
        ...mapMutations({
            fireFlexEvent: FIRE_FLEX_EVENT,
        }),

        activeClass(index) {
            return index === this.activeIndex ? STATE_CLASSES.SELECTED : '';
        },

        onInput(e) {
            this.inputValueNew = e.target.value;
        },

        changeEvent(e) {
            this.fireFlexEvent(`change-${ this.inputNameNew }`);
            this.fireFlexEvent(`change-${ this.inputNameNew }-${ e.target.value }`);
            this.$emit('facet-selected', e.target.value);
        },
    },
};
</script>
